<template>
  <div v-if="showBetPicker" class="bet-picker">
    <div v-loading="predictionIng" class="popup__box w1150">
      <div class="popup__box__title">
        <div class="pop-title">
          <div class="pop-title__left"><span class="pop-title__left__text">发布竞猜</span></div>
          <div class="pop-title__right">
            <div class="pop-close" @click="hide"><img src="@/assets/desktop/img/close.svg" alt=""></div>
          </div>
        </div>
      </div>
      <div class="popup__box__control">
        <div class="js-control-pop">
          <div class="js-control-pop__left"><span class="js-control-pop__left__text">{{ lotteryName }}</span><span class="js-control-pop__left__text red">{{ lotteryInfo.nextPeriod.period }}</span><span class="js-control-pop__left__text">期</span>
            <div class="js-control-pop__left__timerbox">
              <div class="timerbox">
                <div class="timerbox__hour"><span class="timerbox__hour__number">{{ timer }}</span><span class="timerbox__hour__text"></span></div>
              </div>
            </div>
          </div>
          <div class="js-control-pop__right"><a class="button-outline js-control-pop__right__item" href="" @click.prevent="hide"><span class="button-outline__text">取消</span></a><a class="button-outline js-control-pop__right__item fn-post" href="" :class="{'disable': stopPrediction}" @click.prevent="sendData"><span class="button-outline__text">{{ stopPrediction ? '开奖中...' :'提交' }}</span></a></div>
        </div>
      </div>
      <div class="popup__box__content">
        <div class="pop-table">
          <table class="even-color">
            <thead>
              <tr>
                <th v-for="hm in hmList" :key="hm.value" colspan="2"><span>{{ hm.text }}</span></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(hm,index) in nmMappingList" :key="index">
                <td v-for="(number,key) in nmList[hm.key]" :key="`number-${key}`" :class="{'selected-active':number.active}" colspan="2" @click="selectNm(number.value,key)">
                  {{ number.text }}
                </td>
              </tr>
              <tr>
                <td v-for="(daxiao,idx) in nmList.daxiao" :key="`daxiao-${idx}`" :class="{'selected-active':daxiao.active}" colspan="1" @click="selectNm(daxiao.value,daxiao.target)">
                  {{ daxiao.text }}
                </td>
              </tr>
              <tr>
                <td v-for="(danshuang,idx) in nmList.danshuang" :key="`danshuang-${idx}`" :class="{'selected-active':danshuang.active}" colspan="1" @click="selectNm(danshuang.value,danshuang.target)">
                  {{ danshuang.text }}
                </td>
              </tr>
              <tr>
                <td v-for="(longHu,idx) in nmList.longHu" :key="`longHu-${idx}`" :class="{'selected-active':longHu.active}" colspan="1" @click="selectNm(longHu.value,longHu.target)">
                  {{ longHu.text }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { postPredictions_web, checkPrediction_web } from '@/api/desktop/betLottery'
export default {
  name: 'BetPicker',
  props: {
    showBetPicker: {
      type: Boolean,
      default: false
    },
    lotteryInfo: {
      type: Object,
      default: Object
    },
    timer: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      predictionIng: false,
      stopPrediction: false,
      hasPrediciton: '',
      lotteryName: '',
      initDataDone: false,
      currentHm: 'hm1',
      hmList: [
        {
          text: '冠军',
          value: 'hm1'
        },
        {
          text: '亚军',
          value: 'hm2'
        },
        {
          text: '第三名',
          value: 'hm3'
        },
        {
          text: '第四名',
          value: 'hm4'
        },
        {
          text: '第五名',
          value: 'hm5'
        },
        {
          text: '第六名',
          value: 'hm6'
        },
        {
          text: '第七名',
          value: 'hm7'
        },
        {
          text: '第八名',
          value: 'hm8'
        },
        {
          text: '第九名',
          value: 'hm9'
        },
        {
          text: '第十名',
          value: 'hm10'
        }
      ],
      nmList: {
        number1: {
          hm1: {
            text: 1,
            value: 1,
            active: false
          },
          hm2: {
            text: 1,
            value: 1,
            active: false
          },
          hm3: {
            text: 1,
            value: 1,
            active: false
          },
          hm4: {
            text: 1,
            value: 1,
            active: false
          },
          hm5: {
            text: 1,
            value: 1,
            active: false
          },
          hm6: {
            text: 1,
            value: 1,
            active: false
          },
          hm7: {
            text: 1,
            value: 1,
            active: false
          },
          hm8: {
            text: 1,
            value: 1,
            active: false
          },
          hm9: {
            text: 1,
            value: 1,
            active: false
          },
          hm10: {
            text: 1,
            value: 1,
            active: false
          }
        },
        number2: {
          hm1: {
            text: 2,
            value: 2,
            active: false
          },
          hm2: {
            text: 2,
            value: 2,
            active: false
          },
          hm3: {
            text: 2,
            value: 2,
            active: false
          },
          hm4: {
            text: 2,
            value: 2,
            active: false
          },
          hm5: {
            text: 2,
            value: 2,
            active: false
          },
          hm6: {
            text: 2,
            value: 2,
            active: false
          },
          hm7: {
            text: 2,
            value: 2,
            active: false
          },
          hm8: {
            text: 2,
            value: 2,
            active: false
          },
          hm9: {
            text: 2,
            value: 2,
            active: false
          },
          hm10: {
            text: 2,
            value: 2,
            active: false
          }
        },
        number3: {
          hm1: {
            text: 3,
            value: 3,
            active: false
          },
          hm2: {
            text: 3,
            value: 3,
            active: false
          },
          hm3: {
            text: 3,
            value: 3,
            active: false
          },
          hm4: {
            text: 3,
            value: 3,
            active: false
          },
          hm5: {
            text: 3,
            value: 3,
            active: false
          },
          hm6: {
            text: 3,
            value: 3,
            active: false
          },
          hm7: {
            text: 3,
            value: 3,
            active: false
          },
          hm8: {
            text: 3,
            value: 3,
            active: false
          },
          hm9: {
            text: 3,
            value: 3,
            active: false
          },
          hm10: {
            text: 3,
            value: 3,
            active: false
          }
        },
        number4: {
          hm1: {
            text: 4,
            value: 4,
            active: false
          },
          hm2: {
            text: 4,
            value: 4,
            active: false
          },
          hm3: {
            text: 4,
            value: 4,
            active: false
          },
          hm4: {
            text: 4,
            value: 4,
            active: false
          },
          hm5: {
            text: 4,
            value: 4,
            active: false
          },
          hm6: {
            text: 4,
            value: 4,
            active: false
          },
          hm7: {
            text: 4,
            value: 4,
            active: false
          },
          hm8: {
            text: 4,
            value: 4,
            active: false
          },
          hm9: {
            text: 4,
            value: 4,
            active: false
          },
          hm10: {
            text: 4,
            value: 4,
            active: false
          }
        },
        number5: {
          hm1: {
            text: 5,
            value: 5,
            active: false
          },
          hm2: {
            text: 5,
            value: 5,
            active: false
          },
          hm3: {
            text: 5,
            value: 5,
            active: false
          },
          hm4: {
            text: 5,
            value: 5,
            active: false
          },
          hm5: {
            text: 5,
            value: 5,
            active: false
          },
          hm6: {
            text: 5,
            value: 5,
            active: false
          },
          hm7: {
            text: 5,
            value: 5,
            active: false
          },
          hm8: {
            text: 5,
            value: 5,
            active: false
          },
          hm9: {
            text: 5,
            value: 5,
            active: false
          },
          hm10: {
            text: 5,
            value: 5,
            active: false
          }
        },
        number6: {
          hm1: {
            text: 6,
            value: 6,
            active: false
          },
          hm2: {
            text: 6,
            value: 6,
            active: false
          },
          hm3: {
            text: 6,
            value: 6,
            active: false
          },
          hm4: {
            text: 6,
            value: 6,
            active: false
          },
          hm5: {
            text: 6,
            value: 6,
            active: false
          },
          hm6: {
            text: 6,
            value: 6,
            active: false
          },
          hm7: {
            text: 6,
            value: 6,
            active: false
          },
          hm8: {
            text: 6,
            value: 6,
            active: false
          },
          hm9: {
            text: 6,
            value: 6,
            active: false
          },
          hm10: {
            text: 6,
            value: 6,
            active: false
          }
        },
        number7: {
          hm1: {
            text: 7,
            value: 7,
            active: false
          },
          hm2: {
            text: 7,
            value: 7,
            active: false
          },
          hm3: {
            text: 7,
            value: 7,
            active: false
          },
          hm4: {
            text: 7,
            value: 7,
            active: false
          },
          hm5: {
            text: 7,
            value: 7,
            active: false
          },
          hm6: {
            text: 7,
            value: 7,
            active: false
          },
          hm7: {
            text: 7,
            value: 7,
            active: false
          },
          hm8: {
            text: 7,
            value: 7,
            active: false
          },
          hm9: {
            text: 7,
            value: 7,
            active: false
          },
          hm10: {
            text: 7,
            value: 7,
            active: false
          }
        },
        number8: {
          hm1: {
            text: 8,
            value: 8,
            active: false
          },
          hm2: {
            text: 8,
            value: 8,
            active: false
          },
          hm3: {
            text: 8,
            value: 8,
            active: false
          },
          hm4: {
            text: 8,
            value: 8,
            active: false
          },
          hm5: {
            text: 8,
            value: 8,
            active: false
          },
          hm6: {
            text: 8,
            value: 8,
            active: false
          },
          hm7: {
            text: 8,
            value: 8,
            active: false
          },
          hm8: {
            text: 8,
            value: 8,
            active: false
          },
          hm9: {
            text: 8,
            value: 8,
            active: false
          },
          hm10: {
            text: 8,
            value: 8,
            active: false
          }
        },
        number9: {
          hm1: {
            text: 9,
            value: 9,
            active: false
          },
          hm2: {
            text: 9,
            value: 9,
            active: false
          },
          hm3: {
            text: 9,
            value: 9,
            active: false
          },
          hm4: {
            text: 9,
            value: 9,
            active: false
          },
          hm5: {
            text: 9,
            value: 9,
            active: false
          },
          hm6: {
            text: 9,
            value: 9,
            active: false
          },
          hm7: {
            text: 9,
            value: 9,
            active: false
          },
          hm8: {
            text: 9,
            value: 9,
            active: false
          },
          hm9: {
            text: 9,
            value: 9,
            active: false
          },
          hm10: {
            text: 9,
            value: 9,
            active: false
          }
        },
        number10: {
          hm1: {
            text: 10,
            value: 10,
            active: false
          },
          hm2: {
            text: 10,
            value: 10,
            active: false
          },
          hm3: {
            text: 10,
            value: 10,
            active: false
          },
          hm4: {
            text: 10,
            value: 10,
            active: false
          },
          hm5: {
            text: 10,
            value: 10,
            active: false
          },
          hm6: {
            text: 10,
            value: 10,
            active: false
          },
          hm7: {
            text: 10,
            value: 10,
            active: false
          },
          hm8: {
            text: 10,
            value: 10,
            active: false
          },
          hm9: {
            text: 10,
            value: 10,
            active: false
          },
          hm10: {
            text: 10,
            value: 10,
            active: false
          }
        },
        daxiao: [
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm1'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm1'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm2'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm2'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm3'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm3'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm4'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm4'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm5'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm5'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm6'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm6'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm7'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm7'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm8'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm8'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm9'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm9'
          },
          {
            text: '大',
            value: 'daxiao_da',
            active: false,
            target: 'hm10'
          },
          {
            text: '小',
            value: 'daxiao_xiao',
            active: false,
            target: 'hm10'
          }
        ],
        danshuang: [
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm1'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm1'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm2'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm2'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm3'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm3'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm4'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm4'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm5'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm5'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm6'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm6'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm7'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm7'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm8'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm8'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm9'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm9'
          },
          {
            text: '单',
            value: 'danshuang_dan',
            active: false,
            target: 'hm10'
          },
          {
            text: '双',
            value: 'danshuang_shuang',
            active: false,
            target: 'hm10'
          }
        ],
        longHu:
        [
          {
            text: '龙',
            value: 'longHu_long',
            active: false,
            target: 'hm1'
          },
          {
            text: '虎',
            value: 'longHu_hu',
            active: false,
            target: 'hm1'
          },
          {
            text: '龙',
            value: 'longHu_long',
            active: false,
            target: 'hm2'
          },
          {
            text: '虎',
            value: 'longHu_hu',
            active: false,
            target: 'hm2'
          },
          {
            text: '龙',
            value: 'longHu_long',
            active: false,
            target: 'hm3'
          },
          {
            text: '虎',
            value: 'longHu_hu',
            active: false,
            target: 'hm3'
          },
          {
            text: '龙',
            value: 'longHu_long',
            active: false,
            target: 'hm4'
          },
          {
            text: '虎',
            value: 'longHu_hu',
            active: false,
            target: 'hm4'
          },
          {
            text: '龙',
            value: 'longHu_long',
            active: false,
            target: 'hm5'
          },
          {
            text: '虎',
            value: 'longHu_hu',
            active: false,
            target: 'hm5'
          }
        ]
      },
      nmMappingList: [
        {
          key: 'number1',
          value: 'hm1'
        },
        {
          key: 'number2',
          value: 'hm2'
        },
        {
          key: 'number3',
          value: 'hm3'
        },
        {
          key: 'number4',
          value: 'hm4'
        },
        {
          key: 'number5',
          value: 'hm5'
        },
        {
          key: 'number6',
          value: 'hm6'
        },
        {
          key: 'number7',
          value: 'hm7'
        },
        {
          key: 'number8',
          value: 'hm8'
        },
        {
          key: 'number9',
          value: 'hm9'
        },
        {
          key: 'number10',
          value: 'hm10'
        }
      ],
      referenceMapping: {},
      daxiaoList: [

      ],
      danshuangList: [

      ],
      longHuList: [

      ],
      resultData: {
        hm1: {},
        hm2: {},
        hm3: {},
        hm4: {},
        hm5: {},
        hm6: {},
        hm7: {},
        hm8: {},
        hm9: {},
        hm10: {}
      }
    }
  },
  computed: {
    hideLongHu() {
      return this.currentHm.match(/\d+$/)[0] < 6
    },
    buttonText() {
      if (this.stopPrediction) {
        return '开奖中...'
      } else if (this.hasPrediciton) {
        return '本期已发'
      } else if (this.predictionIng) {
        return '提交中...'
      } else {
        return '提交'
      }
    }
  },
  watch: {
    'lotteryInfo.prePeriod.period': {
      handler(val) {
        this.hasPrediciton = false
      }
    },
    timer(val) {
      if (val === '开奖中...') {
        this.stopPrediction = true
      } else {
        this.stopPrediction = false
      }
    }
  },
  async mounted() {
    this.formatList()

    this.initData()
    this.updateLotteryInfo()
    this.checkHasPrediction()
  },
  methods: {
    formatList() {
      this.nmList.daxiao.forEach(x => {
        this.referenceMapping[`${x.target}_${x.value}`] = x
      })
      this.nmList.danshuang.forEach(x => {
        this.referenceMapping[`${x.target}_${x.value}`] = x
      })
      this.nmList.longHu.forEach(x => {
        this.referenceMapping[`${x.target}_${x.value}`] = x
      })
    },
    async checkHasPrediction() {
      const [data, error] = await checkPrediction_web({ cpCode: this.lotteryInfo.prePeriod.cpCode, period: this.lotteryInfo.nextPeriod.period })
      if (error) return
      this.hasPrediciton = data
      this.$emit('checkHasPrediction', this.hasPrediciton)
    },
    initData() {
      this.hmList.forEach(hm => {
        this.resultData[hm.value].field = hm.value
        this.resultData[hm.value].daxiao_da = false
        this.resultData[hm.value].daxiao_xiao = false
        this.resultData[hm.value].danshuang_dan = false
        this.resultData[hm.value].danshuang_shuang = false
        this.resultData[hm.value].longHu_long = false
        this.resultData[hm.value].longHu_hu = false
      })
      this.initDataDone = true
      this.$forceUpdate()
    },
    async updateLotteryInfo() {
      const [lotteryNameMapping, error] = await this.$store.dispatch('lottery/getLotteryNameMapping')
      if (error) {
        console.warn('取得lotteryNameMapping 失敗!', error)
        return
      }

      this.lotteryName = lotteryNameMapping[this.lotteryInfo.prePeriod.code]
    },
    selectHm(hm) {
      this.currentHm = hm.value
    },
    selectNm(nm, hm, index) {
      switch (nm) {
        case 'danshuang_dan':
          if (!this.resultData[hm].danshuang_dan) {
            this.resultData[hm].danshuang_dan = true
            this.resultData[hm].danshuang_shuang = false
            this.referenceMapping[`${hm}_danshuang_dan`]['active'] = true
            this.referenceMapping[`${hm}_danshuang_shuang`]['active'] = false
          } else {
            this.resultData[hm].danshuang_dan = false
            this.referenceMapping[`${hm}_${nm}`]['active'] = false
          }
          break
        case 'danshuang_shuang':
          if (!this.resultData[hm].danshuang_shuang) {
            this.resultData[hm].danshuang_shuang = true
            this.resultData[hm].danshuang_dan = false
            this.referenceMapping[`${hm}_danshuang_shuang`]['active'] = true
            this.referenceMapping[`${hm}_danshuang_dan`]['active'] = false
          } else {
            this.resultData[hm].danshuang_shuang = false
            this.referenceMapping[`${hm}_${nm}`]['active'] = false
          }
          break
        case 'daxiao_da':
          if (!this.resultData[hm].daxiao_da) {
            this.resultData[hm].daxiao_da = true
            this.resultData[hm].daxiao_xiao = false
            this.referenceMapping[`${hm}_daxiao_da`]['active'] = true
            this.referenceMapping[`${hm}_daxiao_xiao`]['active'] = false
          } else {
            this.resultData[hm].daxiao_da = false
            this.referenceMapping[`${hm}_${nm}`]['active'] = false
          }
          break
        case 'daxiao_xiao':
          if (!this.resultData[hm].daxiao_xiao) {
            this.resultData[hm].daxiao_xiao = true
            this.resultData[hm].daxiao_da = false
            this.referenceMapping[`${hm}_daxiao_xiao`]['active'] = true
            this.referenceMapping[`${hm}_daxiao_da`]['active'] = false
          } else {
            this.resultData[hm].daxiao_xiao = false
            this.referenceMapping[`${hm}_${nm}`]['active'] = false
          }
          break
        case 'longHu_hu':
          if (!this.resultData[hm].longHu_hu) {
            this.resultData[hm].longHu_hu = true
            this.resultData[hm].longHu_long = false
            this.referenceMapping[`${hm}_longHu_hu`]['active'] = true
            this.referenceMapping[`${hm}_longHu_long`]['active'] = false
          } else {
            this.resultData[hm].longHu_hu = false
            this.referenceMapping[`${hm}_${nm}`]['active'] = false
          }
          break
        case 'longHu_long':
          if (!this.resultData[hm].longHu_long) {
            this.resultData[hm].longHu_long = true
            this.resultData[hm].longHu_hu = false
            this.referenceMapping[`${hm}_longHu_long`]['active'] = true
            this.referenceMapping[`${hm}_longHu_hu`]['active'] = false
          } else {
            this.resultData[hm].longHu_long = false
            this.referenceMapping[`${hm}_${nm}`]['active'] = false
          }
          break
        case 1:
          if (!this.resultData[hm][1]) {
            this.resultData[hm][nm] = true
            this.nmList.number1[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number1[hm].active = false
          }
          break
        case 2:
          if (!this.resultData[hm][2]) {
            this.resultData[hm][nm] = true
            this.nmList.number2[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number2[hm].active = false
          }
          break
        case 3:
          if (!this.resultData[hm][3]) {
            this.resultData[hm][nm] = true
            this.nmList.number3[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number3[hm].active = false
          }
          break
        case 4:
          if (!this.resultData[hm][4]) {
            this.resultData[hm][nm] = true
            this.nmList.number4[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number4[hm].active = false
          }
          break
        case 5:
          if (!this.resultData[hm][5]) {
            this.resultData[hm][nm] = true
            this.nmList.number5[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number5[hm].active = false
          }
          break
        case 6:
          if (!this.resultData[hm][6]) {
            this.resultData[hm][nm] = true
            this.nmList.number6[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number6[hm].active = false
          }
          break
        case 7:
          if (!this.resultData[hm][7]) {
            this.resultData[hm][nm] = true
            this.nmList.number7[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number7[hm].active = false
          }
          break
        case 8:
          if (!this.resultData[hm][8]) {
            this.resultData[hm][nm] = true
            this.nmList.number8[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number8[hm].active = false
          }
          break
        case 9:
          if (!this.resultData[hm][9]) {
            this.resultData[hm][nm] = true
            this.nmList.number9[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number9[hm].active = false
          }
          break
        case 10:
          if (!this.resultData[hm][10]) {
            this.resultData[hm][nm] = true
            this.nmList.number10[hm].active = true
          } else {
            this.resultData[hm][nm] = false
            this.nmList.number10[hm].active = false
          }
          break
      }
      this.$forceUpdate()
    },
    hide() {
      this.initData()
      this.$emit('hidePopup', false)
    },
    formatQuery() {
      const guess = []
      this.hmList.forEach(hm => {
        const obj = {
          field: '',
          drawResult: []
        }
        for (const prop in this.resultData[hm.value]) {
          if (this.resultData[hm.value][prop] === true) {
            obj.drawResult.push(prop)
          }
        }
        if (obj.drawResult.length > 0) {
          obj.field = hm.value
          guess.push(obj)
        }
      })
      const temp = {
        cpCode: this.$route.params.lottery_code,
        period: this.lotteryInfo.nextPeriod.period,
        guesses: guess
      }
      return temp
    },
    async sendData() {
      if (this.hasPrediciton || this.stopPrediction || this.predictionIng) return
      const query = this.formatQuery()
      if (query.guesses.length === 0) {
        this.$msgbox('请先选择竞猜项目', '提示', {
          confirmButtonText: '确定',
          callback: action => {

          }
        })
      } else {
        this.predictionIng = true
        const [data, error] = await postPredictions_web(query)
        if (error) {
          this.$msgbox(error.data.message, '提示', {
            confirmButtonText: '确定'
          }).then(action => {
            this.predictionIng = false
          }).catch(err => {
            console.log(err)
            this.predictionIng = false
          })
        } else {
          this.$msgbox(data, '提示', {
            confirmButtonText: '确定'
          }).then(async action => {
            await this.checkHasPrediction()
            this.hide()
            this.$emit('setUpdateMyLotteryBet', true)
            this.predictionIng = false
          }).catch(async(err) => {
            console.log(err)
            await this.checkHasPrediction()
            this.$emit('setUpdateMyLotteryBet', true)
            this.predictionIng = false
            this.hide()
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
  background-color:red;
}
.quiz-popup .popup .checkbox-list {
  display: flex;
  flex-wrap:wrap;
}
.fn-wrap {
    display: flex;
    justify-content: center;
    width: 20%;
}
.name {
    width: 90%;
    display: flex;
    align-items: center;
}
.fn-container {
  display: flex;
  flex-wrap:wrap;
  .checkbox-list {
    width :33%;
  }
}
.bet-picker {
  position: fixed;
  top:50%;
  left:50%;
  z-index:10;
  transform: translate(-50%, -50%);
}
.header-container {
  height: 45px;
  line-height: 45px;
  background-color: #f0f0f0;
  display: flex;
  justify-content: space-between;

  .frontend-confirm {
    color: #50b0c5;
  }
}

.header-item {
  margin: 0 25px;
}

.body-container {
  height: 230px;

  .select-options {
    display: flex;
    justify-content: center;

    &__item {
      height: 40px;
      line-height: 40px;
      font-weight: 500;
      margin: 0 30px;
    }
  }

  .check-box-container {
    margin: 5 5px;
    display:flex;
    justify-self: space-between;
    flex-wrap:wrap;
    .hm-box {
      width:20%
    }
    .check-box-item {
      border: #e4e3e8 solid 1px;
      padding: 6px 0;
      margin: 2px 2px;
      border-radius: 3px;
      text-align: center;
    }

    .border-blue {
      color: #50b0c5;
      border-color: #50b0c5;
    }
  }
  .disabled {
    color:#e5e5e5
  }
}
.popup {
  position: fixed;
    bottom: 15%;
    max-height: 60vh;
    overflow: scroll;
}
.selected-active {
  background-color:#178AFF;
  color:#fff
}
.fn-post {
  color: #178AFF;
  box-shadow: inset 0 0 0 1px #178AFF;
}
</style>
